import React from 'react';
import styled from 'styled-components';

import { animation, colors, grid } from '../config';
import { media } from '../utils/responsive';
import GridCell from './grid/grid-cell';

const AlertCell = styled(GridCell)`
  width: 100%;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: ${animation.transition};
  padding: ${({ visible }) => !visible && `0 ${grid.gutters.small / 2}px`};

  ${media.medium`
    padding: ${({ visible }) => !visible && `0 ${grid.gutters.medium / 2}px`};
  `};
`;

const StyledAlert = styled.div`
  width: 100%;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.3rem;
  height: ${({ visible }) => (visible ? 'auto' : 0)};
  padding: ${({ visible }) => (visible ? '16px' : '0 16px')};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  background: ${({ type }) => colors.alert[type]};
  transition: ${animation.transition};
`;

const Alert = ({ visible, type, children }) => (
  <AlertCell visible={visible}>
    <StyledAlert visible={visible} type={type}>
      {children}
    </StyledAlert>
  </AlertCell>
);

export default Alert;
